<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <label>از تاریخ</label>
                    <Datepicker simple auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="fromDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <label> تا تاریخ</label>
                    <Datepicker simple auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="toDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="form-group col-md-3">
                    <label for="national-code">کد ملی/شناسه ملی</label>
                    <div class="input-group">
                        <input class="form-control text-left" :maxlength="maxLength" id="national-code" type="tel" v-model="nationalCode">
                    </div>
                </div>
                 <div class="form-group col-md-3">
                   <label>شماره همراه</label>
                    <input type="tel" class="form-control" v-model="mobileNumber" v-mask="'09##-#######'">
                </div>
                  <div class="col-md-3">
                    <div class="form-group">
                        <label>شماره کارت</label>
                           <div class="input-group">
                                    <input type="tel" class="form-control text-center" v-mask="'####-####-####-####'" v-model="pan" dir="ltr" style="direction: ltr !important">
                                    <span class="input-group-btn" v-if="pan && pan.replace(/-/g,'').length == 16"></span>
                            </div>
                    </div>
                </div>
            </div>
              <div class="row" style="display: flex; justify-content: end">
                  <div v-if="isSearched" class="col-md-3">
                     <button class="btn btn-warning btn-block" @click="getExelPath">
                         دریافت فایل اکسل
                     </button>
                 </div>
                <div class="col-md-3">
                    <button class="btn btn-primary btn-block" @click="submit" >
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <hr v-if="rows.length">
            <table class="table table-hover table-bordered mb-0" v-if="rows.length">
                <thead>
                    <tr>
                        <th>نام</th>
                        <th>نام خانوادگی</th>
                        <th>وضعیت</th>
                        <th>کدملی</th>
                        <th>شماره همراه</th>
                        <th>شماره کارت</th>
                        <th>تاریخ ایجاد</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,index) in rows" :key="index">
                        <td>{{ row.firstName  }}</td>
                        <td>{{ row.lastName  }}</td>
                        <td>{{ row.status  }}</td>
                        <td>{{ row.nationalCode }}</td>
                        <td>{{ row.mobileNo }}</td>
                        <td>{{ row.cardNumber  }}</td>
                        <td>{{ row.dateCreate}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"><i class="icon ion-ios-arrow-forward"></i></a>
                        </li>
                        <li :class="currentPage == page ? 'page-item active' : 'page-item'" v-for="(page , index) in pages" :key="index">
                            <div style="display: flex; flex-direction: row;" >
                                <span class="page-link ml-1" v-if="page > pages[index-1] + 1 " > ... </span>
                                <a class="page-link" href="#" v-on:click="currentPage = page">{{ page }}</a>
                            </div>
                        </li> 
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"><i class="icon ion-ios-arrow-back"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'TransactionsList',
    data(){
        return {
            showLoading: false,
            isSearched: false,
            rows: [],
            fromDate: '',
            today :moment().format('jYYYY-jMM-jDD'),
            toDate: '',
            mobileNumber:"",
            pan:"",
            currentPage: 1,
            pages: [1],
            perPage: 10,
            count: 0,
            nationalCode:""
        }
    },
    watch: {
        currentPage(value){
            this.currentPage = value;
            this.getData();
        },
    },
    methods: {
        handlePaginateArray(pagesCount){
            let pagesArray = [1];
            if(pagesCount > 1){
               if(this.currentPage > 2) pagesArray.push(this.currentPage -1)
               if(this.currentPage > 1)  pagesArray.push(this.currentPage)
               if(this.currentPage < pagesCount) pagesArray.push(this.currentPage +1)
               const middle =  Math.ceil(pagesCount/ 2)
               if(middle >  this.currentPage +1  && middle < pagesCount-2){
                    pagesArray.push(middle)
               }
                if(this.currentPage < pagesCount) pagesArray.push(pagesCount)
                

            }
            this.pages = pagesArray;
        },
        getExelPath(){
            this.showLoading = true;
            const postedData = {
                fromDate:this.fromDate? this.fromDate.replace(/\//g,''): null,
                toDate:this.toDate? this.toDate.replace(/\//g,'') : null,
                page: this.currentPage,
                perPage: this.perPage,
                mobileNumber: this.mobileNumber ?this.mobileNumber: null,
                nationalCode: this.nationalCode ?this.nationalCode : null,
                cardNumber:this.pan? this.pan.replace(/-/g,'') : null,
            };
            this.$api.post('cards/getCardListExcel',postedData).then(({data}) => {
                if(data.status){
                    let a = window.document.createElement('a');
                    a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result.fileName);
                    let fileName = data.result.filename;
                    a.setAttribute('download',fileName);
                    window.document.body.appendChild(a);
                    a.click();
                    window.document.body.removeChild(a);
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
            });
        },
        getData(){
            this.showLoading = true;
            const postedData = {
                fromDate:this.fromDate? this.fromDate.replace(/\//g,''): null,
                toDate:this.toDate? this.toDate.replace(/\//g,'') : null,
                page: this.currentPage,
                perPage: this.perPage,
                mobileNumber: this.mobileNumber ?this.mobileNumber: null,
                nationalCode: this.nationalCode ?this.nationalCode : null,
                cardNumber:this.pan? this.pan.replace(/-/g,'') : null,
            };
            this.$api.post('Cards/GetCardList',postedData).then(({data}) => {
                if(data.status){
                    this.rows = data.result.list;
                    this.count = data.result.totalCount;
                    this.isSearched = true;
                    this.showLoading = false;
                    let calcPages = Math.ceil((data.result.totalCount) / this.perPage);
                    this.handlePaginateArray(calcPages);
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
            });
        },
        submit(){
            this.getData();
        },
    },
}
</script>